module.exports = __webpack_public_path__ + "img/vo.fce3b528.svg";